export enum SiteStatusType {
  CTMS_STATUS = 'ctms_status',
  EC_APPROVAL_STATUS = 'ec_approval_status',
}
